<template>
  <section v-if="reservation && reservation.slot && reservation.slot.id">
    <h3>
      <font-awesome-icon :icon="['fas', 'layer-group']"></font-awesome-icon>
      {{ t.getOrKey("Label.SelectedServices") }}
    </h3>
    <div v-for="service in reservation.services" :key="service.id">
      <div>
        <h4>{{ service.name }}</h4>
        <div v-if="service.givenAnswers && service.givenAnswers.length">
          <div v-for="aq in service.givenAnswers" :key="aq.question.id">
            <label>{{ aq.question.question }}:</label>
            <span>&nbsp;{{ aq.displayValue }}</span>
          </div>
        </div>
        <div v-if="service.selectedOptions && service.selectedOptions.length">
          <h5>{{ t.getOrKey("Label.SelectedServiceAdditionalOptions") }}</h5>

          <div v-for="opt in service.selectedOptions" :key="opt.id">
            {{ opt.name }}
            {{ opt.priceInEURCents > 0 ? opt.priceInEURCents / 100 + "€" : "" }}
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div>
      <h3>
        <font-awesome-icon
          :icon="['fas', 'map-marker-alt']"
        ></font-awesome-icon>
        {{ t.getOrKey("Label.Provider") }}
      </h3>
      <div>
        <label>{{ reservation.provider.name }}</label>
      </div>
      <div>{{ reservation.provider.street }}</div>
      <div>{{ reservation.provider.city }}</div>
    </div>
    <hr />
    <div>
      <h3>
        <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
        {{ t.getOrKey("Label.Time") }}
      </h3>
      <div>
        <label>{{ t.getOrKey("Label.Start") }}:</label>
        {{ formatDate(reservation.slot.start) + " klo " }}
        {{ formatTime(reservation.slot.start) }}
      </div>
    </div>
    <hr />
    <h3>
      <font-awesome-icon :icon="['fas', 'user-edit']"></font-awesome-icon>
      {{ t.getOrKey("Label.ReserverDetails") }}
    </h3>
    <div>
      <label>{{ t.getOrKey("Label.ReserverName") }}:</label>
      <span>&nbsp;{{ reservation.name }}</span>
    </div>

    <div>
      <label>{{ t.getOrKey("Label.RegistrationNumber") }}:</label>
      <span>&nbsp;{{ reservation.registration }}</span>
    </div>
    <div>
      <label>{{ t.getOrKey("Label.Email") }}:</label>
      <span>&nbsp;{{ reservation.email }}</span>
    </div>
    <div>
      <label>{{ t.getOrKey("Label.ReserverPhone") }}:</label>
      <span>&nbsp;{{ reservation.phone }}</span>
    </div>
    <div>
      <div>
        <label>{{ t.getOrKey("Label.AdditionalInfo") }}</label>
      </div>
      <div>{{ reservation.additionalInfo }}</div>
    </div>
    <hr />
    <div v-if="false" class="smsContainer">
      <label class="switch">
        <input type="checkbox" v-model="sendRemindSMS" id="sendRemindTxt" />
        <span class="slider round"></span>
      </label>
      <label for="sendRemindTxt"
        >&nbsp;{{ t.getOrKey("Label.SendRemindSMS") }}</label
      >
    </div>

    <div v-if="reservation.services.some(s => s.useConfirmDisclaimer)"
      v-html="t.getOrKey('Label.AgreeReservationTermsText')"
      class="info"
    ></div>

    <div v-if="reservation.services.some(s => s.useConfirmDisclaimer)"
      style="margin-bottom: 20px;"
      :class="{ error: hasValidateRun && !isTermsAgreed }"
    >
      <label class="switch">
        <input type="checkbox" v-model="isTermsAgreed" id="agreeTerms" />
        <span class="slider round"></span>
      </label>
      <label for="agreeTerms">&nbsp;{{ t.getOrKey("Label.AgreeTerms") }}</label>
    </div>

    <div>
      <Loader :loading="submitting"></Loader>
      <button v-if="!submitting" class="primary" type="button" @click="confirm">
        {{ t.getOrKey("Button.Confirm") }}
      </button>
    </div>
  </section>
</template>
<script>
import util from "@/services/utils";
import api from "@/services/api-service";
import t from "@/services/translation-service";
import Loader from "./Loader.vue";
import Vue from "vue";

export default {
  components: {
    Loader,
  },
  props: {
    reservation: Object,
  },
  watch: {
    reservation: {
      deep: true,
      handler() {
        return this.reservation;
      },
    },
  },
  data() {
    return {
      t: t,
      sendRemindSMS: false,
      submitting: false,
      isTermsAgreed: false,
      hasValidateRun: false,
    };
  },

  methods: {
    handleValidation() {
      const vm = this;
      const data = { isValid: true, scrollTo: "" };
      vm.$emit("validate", data);
      vm.hasValidateRun = true;
      const v = Vue.nextTick().then(() => {
        return Vue.nextTick().then(() => {
          return data.isValid && (vm.isTermsAgreed || !vm.reservation.services.some(s => s.useConfirmDisclaimer));
        });
      });
      return v;
    },
    confirm() {
      const vm = this;
      if (vm.submitting) {
        return;
      }
      vm.handleValidation().then((isValid) => {
        if (isValid) {
          vm.submit();
        }
      });
    },
    submit() {
      let vm = this;
      this.submitting = true;
      const order = {
        ReservationId: this.reservation.slot.reservationId,
        Name: this.reservation.name,
        Phone: this.reservation.phone,
        Answers: this.reservation.services.reduce((result, service) => {
          const ans = service.givenAnswers.map((aq) => {
            return { QuestionId: aq.question.id, Answer: aq.value };
          });
          const res = (result || []).concat(ans);
          return res;
        }, []),
        ServiceAdditionalOptions: this.reservation.services.reduce(
          (result, service) => {
            const opts = service.selectedOptions.map((o) => o.id);
            const res = (result || []).concat(opts);
            return res;
          },
          []
        ), /// todo
        Email: this.reservation.email,
        RegistrationNumber: this.reservation.registration,
        AdditionalInfo: this.reservation.additionalInfo,
        SendRemindSMS: this.sendRemindSMS,
      };
      api
        .confirm(order)
        .then((response) => {
          const event = "reservationConfirmed";
          while (vm && !vm.$listeners[event]) {
            vm = vm.$parent;
          }
          if (!vm)
            return console.error(`no target listener for event "${event}"`);

          vm.$emit(event, response.data.id, vm.reservation);
        })
        .catch((error) => {
          if (error?.response?.data?.code) {
            if (error.response.data.code === "SlotTaken") {
              alert(
                "Valitsemasi aika ehdittiin valitettavasti varata. Ole hyvä ja valitse uusi aika."
              );
              this.$emit("reservationSlotTaken", {});
            }
          }
          console.log(error.response);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    formatDate: util.formatDate,
    formatTime: util.formatTime,
  },
};
</script>
<style scoped>
hr {
  border: solid 1px #f1f1f1;
  margin-top: 22px;
}
.smsContainer {
  margin-bottom: 2rem;
}
label {
  font-weight: 500;
}
</style>
